/**
 * @file コンポーネント：ポップアップ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";

// スタイル読み込み
import {
    StyledPopup,
    StyledPopupContainerButton,
    StyledPopupContainerButtonlist,
    StyledPopupContainerButtonlistItem,
    StyledPopupContainer,
    StyledPopupContainerClose,
    StyledPopupContainerContent,
    StyledPopupContainerHeader,
} from "./style";

// 関数読み込み
import { fnIsTouchDevice } from "~/src/functions/boolean";

// フック読み込み
import { mediaQuery, useMediaQuery } from "~/src/hooks/mediaQuery";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <>
            {fnIsTouchDevice() === false &&
            useMediaQuery(mediaQuery.pcOrPcWide) === true ? (
                // タッチデバイスではないかつ画面サイズPC以上の場合
                <StyledPopup
                    className={[
                        props.isFullHeight === true && "is-fullheight",
                        props.isHighlight === true && "is-highlight",
                        props.isOpen === true && "is-open",
                    ]}
                    data-position={props.position}
                    onMouseDown={() => props.fnSetPopupZIndex()}
                    ref={props.refPopup}
                    style={{ zIndex: props.popupZIndex }}
                >
                    <StyledPopupContainer>
                        {/* 見出し */}
                        <StyledPopupContainerHeader
                            className={props.headline && "has-headline"}
                            dangerouslySetInnerHTML={{
                                __html: props.headline,
                            }}
                            onMouseDown={() => props.setIsDrag(true)}
                            onMouseMove={(e) => props.fnOnMouseMove(e)}
                            onMouseUp={() => props.setIsDrag(false)}
                        />
                        {/* ×ボタン */}
                        <StyledPopupContainerClose
                            onClick={() => props.setIsOpen(false)}
                            onMouseDown={(e) => e.stopPropagation()}
                            title={localized["Label.Close"]}
                        >
                            <i className="fas fa-times"></i>
                        </StyledPopupContainerClose>
                        {/* 内容 */}
                        <StyledPopupContainerContent>
                            {props.content}
                        </StyledPopupContainerContent>
                        {/* ボタンリスト */}
                        {Array.isArray(props.buttonlist) === true &&
                            props.buttonlist.length > 0 && (
                                <StyledPopupContainerButtonlist>
                                    {props.buttonlist.map((button, index) => (
                                        <StyledPopupContainerButtonlistItem
                                            key={"button-" + index}
                                        >
                                            <StyledPopupContainerButton
                                                data-button-type={
                                                    button.buttonType
                                                }
                                                href={
                                                    button.href
                                                        ? button.href
                                                        : "#"
                                                }
                                                onClick={button.onClick}
                                            >
                                                {button.text}
                                            </StyledPopupContainerButton>
                                        </StyledPopupContainerButtonlistItem>
                                    ))}
                                </StyledPopupContainerButtonlist>
                            )}
                    </StyledPopupContainer>
                </StyledPopup>
            ) : (
                // タッチデバイスまたは画面サイズPC未満の場合
                <Modal
                    buttonlist={props.buttonlist}
                    content={props.content}
                    hasButtonClose={true}
                    headline={props.headline}
                    isShow={props.isOpen}
                    setIsShow={props.setIsOpen}
                />
            )}
        </>
    );
};
